module.exports = __webpack_public_path__ + "static/media/magic-crystals.863061f1.gif";